import React from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import RaisedButton from "material-ui/RaisedButton";
import {
  loginFormVisible,
  getTokenFromFacebook,
  getToken,
  setToken
} from "../../store/login";
import { forgotPasswordFormVisible } from "../../store/forgotPassword";
import { registerFormVisible } from "../../store/register";
import { storageTokenGet } from "../../core/request";
import TextField from "material-ui/TextField";
import Checkbox from "material-ui/Checkbox";
import FacebookLogin from "react-facebook-login";
import { message } from "../../store/messageBar";
import { updateCartItemsQty } from "../../store/cartItems";
import { updateWalletItemsQty } from "../../store/walletItems";

class LoginForm extends React.Component {
  handleClose = () => {
    this.loginForm(false);
  };

  handleForgot = () => {
    this.props.forgotPasswordFormVisible(true);
  };

  handleSignUp = () => {
    this.props.registerFormVisible(true);
  }

  handleSignIn = () => {
    let valid = true,
      error = {
        login: "",
        password: ""
      };
    if (this.state.form.login === "") {
      error.login = "This field is empty";
      valid = false;
    }
    if (this.state.form.password === "") {
      error.password = "This field is empty";
      valid = false;
    }

    if (valid) {
      this.login(
        this.state.form.login,
        this.state.form.password,
        this.state.form.rememberMe
      )
        .then(() => {
          this.props.updateCartItemsQty();
          this.props.updateWalletItemsQty();
          this.handleClose();
        })
        .catch(err => {
          error.login = "Incorrect field";
          error.password = "Incorrect field";
          this.setState({ error: error });
          this.showMessage("Incorrect login or password");
        });
    } else {
      this.setState({ error: error });
    }
  };

  handleInput = e => {
    let form = this.state.form;
    let error = this.state.error;
    form[e.target.id] = e.target.value;
    if (e.target.value !== "") {
      error[e.target.id] = "";
    }
    this.setState({
      form: form,
      error: error
    });
  };

  updateCheck = () => {
    let form = this.state.form;
    form.rememberMe = !this.state.form.rememberMe;
    this.setState(form);
  };

  constructor(props) {
    super(props);

    this.state = {
      showWindow: this.props.showWindow,
      form: {
        login: "",
        password: "",
        rememberMe: false
      },
      error: {
        login: "",
        password: ""
      }
    };
    this.loginForm = this.props.loginWindow;
    this.getTokenFromFacebook = this.props.getTokenFromFacebook;
    this.login = this.props.login;
    this.showMessage = this.props.showMessage;

    // check token in storage
    this.props.setToken(storageTokenGet());
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showWindow !== this.state.showWindow) {
      this.setState({ showWindow: nextProps.showWindow });
    }
  }

  responseFacebook = response => {
    this.getTokenFromFacebook(response.accessToken).then(() => {
      this.props.updateCartItemsQty();
      this.props.updateWalletItemsQty();
      this.handleClose();
    });
  };

  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.handleSignIn();
    }
  };

  render() {
    return (
      <div>
        <Dialog
          modal={true}
          open={this.state.showWindow}
          contentClassName={"login-dialog_content sing-page"}
          autoScrollBodyContent={true}
        >
          <div className="dialog-body-wrapper">
            <div className="sing-logo-container">              
              <p>
                Deal Marketplace™ <b>Sign In</b>
              </p>
              <i className="material-icons" onClick={this.handleClose}>
                close
              </i>
            </div>
            <p className="marketplace-banner">           
            </p>
            <div className="sing-text-wrp">
              <p className="w-100">
                <i>
                  If you currently have a Deal Marketplace™ or Xooker account, please sign in using
                  the same email and password.
                </i>
              </p>
            </div>
            <div className="sing-text-wrp">
              <p className="w-100">
                <i>
                  Don't have a Deal Marketplace™ or Xooker Account? 
                </i>
                <RaisedButton
                  className="sign-up-button"
                  label="Sign Up"
                  onClick={this.handleSignUp}
                  backgroundColor="#323993"
                  labelColor="#ffffff"
                />


              </p>
            </div>

            <div className="sing-in-action-wrp">
              <div className="field-wrp">
                <TextField
                  hintText="Login Field"
                  floatingLabelText="Login"
                  type="text"
                  id="login"
                  onChange={this.handleInput}
                  value={this.state.form.login}
                  underlineFocusStyle={{ borderColor: "#333c8f" }}
                  floatingLabelStyle={{ color: "#333c8f" }}
                  errorText={this.state.error.login}
                  onKeyPress={this.handleKeyPress}
                  className="input-field"
                />
                <br />
                <TextField
                  hintText="Password Field"
                  floatingLabelText="Password"
                  type="password"
                  id="password"
                  onChange={this.handleInput}
                  value={this.state.form.password}
                  underlineFocusStyle={{ borderColor: "#333c8f" }}
                  floatingLabelStyle={{ color: "#333c8f" }}
                  errorText={this.state.error.password}
                  onKeyPress={this.handleKeyPress}
                  className="input-field"
                />
                <br />
                <Checkbox
                  className={"remember-check"}
                  label="Remember me"
                  checked={this.state.form.rememberMe}
                  onCheck={this.updateCheck}
                />
              </div>
              <div className="btn-wrp">              
                <RaisedButton
                  className="forgot-pass"
                  label="Forgot Password"
                  onClick={this.handleForgot}
                  backgroundColor="#FFA100"
                  labelColor="#ffffff"
                />
                <FacebookLogin
                  appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                  autoLoad={false}
                  fields="name,email"
                  callback={this.responseFacebook}
                  cssClass="facebook-button-class"
                  icon="fa-facebook"
                />
                <RaisedButton
                  className="sing-in-btn"
                  label="SIGN IN"
                  onClick={this.handleSignIn}
                  backgroundColor="#323993"
                  labelColor="#ffffff"
                  style={{ width: "50%" }}
                />
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    showWindow: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loginWindow: value => dispatch(loginFormVisible(value)),
    login: (email, password) => dispatch(getToken(email, password)),
    getTokenFromFacebook: token => dispatch(getTokenFromFacebook(token)),
    setToken: (token, rememberMe = false) =>
      dispatch(setToken(token, rememberMe)),
    forgotPasswordFormVisible: state =>
      dispatch(forgotPasswordFormVisible(state)),
    registerFormVisible: state => 
      dispatch(registerFormVisible(state)),
    showMessage: text => dispatch(message(text)),
    updateCartItemsQty: () => dispatch(updateCartItemsQty()),
    updateWalletItemsQty: () => dispatch(updateWalletItemsQty()),
    registerWindow: value => dispatch(registerFormVisible(value))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/ModalWindow/LoginForm.js